(function () {
  function notifyLink(box, btn) {
    var link = box.querySelector('[data-vc-notify]');
    if (!link) {
      link = document.createElement('a');
      link.className = 'wt-button--full-width hero__button hero__button--secondary vc-notify-link';
      link.setAttribute('data-vc-notify', '');
      link.innerHTML = '<span class="vc-notify-long">Notify me when available</span><span class="vc-notify-short">Notify me</span>';
      box.appendChild(link);
    }
    link.href = btn.dataset.url;
    link.dataset.handle = btn.dataset.handle;
    link.setAttribute('aria-label', 'Notify me when available: ' + btn.dataset.title);
    return link;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vc-size-btn');
    if (!btn) return;
    var group = btn.closest('[data-vc-size-buttons]');
    var card = btn.closest('color-swatch') || btn.closest('.card-wrapper');
    if (!group || !card) return;
    group.querySelectorAll('.vc-size-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var dim = group.querySelector('[data-vc-size-dim]');
    if (dim) dim.textContent = btn.dataset.dim;
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!a.hasAttribute('data-vc-notify')) a.href = btn.dataset.url;
    });
    var title = card.querySelector('.card__title a');
    if (title) title.textContent = btn.dataset.title;
    function swap(img, url) {
      if (!img || !url) return;
      var pic = img.closest('picture');
      if (pic) pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    }
    swap(card.querySelector('img.card__img:not(.card__img--hover)'), btn.dataset.img);
    swap(card.querySelector('img.card__img--hover'), btn.dataset.img2 || btn.dataset.img);
    card.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = btn.dataset.variantId; });
    card.querySelectorAll('[data-vc-bag]').forEach(function (b) { b.setAttribute('aria-label', 'Add ' + btn.dataset.title + ' to bag'); });
    var tpl = group.querySelector('template[data-vc-price-for="' + btn.dataset.variantId + '"]');
    var priceBox = card.querySelector('.card__price');
    if (tpl && priceBox) priceBox.innerHTML = tpl.innerHTML;
    var avail = btn.dataset.available === '1';
    card.querySelectorAll('.card__quick-add-container, .card__quick-add-container--desktop').forEach(function (box) {
      var form = box.querySelector('product-form, quick-add');
      if (avail && form) {
        form.hidden = false;
        var link = box.querySelector('[data-vc-notify]');
        if (link) link.hidden = true;
      } else {
        if (form) form.hidden = true;
        notifyLink(box, btn).hidden = false;
      }
    });
  });
})();
